import React, { useState, useEffect, useContext } from "react";
import { Grid, Button, Icon } from "semantic-ui-react";

import { DataContext } from "../context/DataContext";

export const Caption = (props) => {
  const { data, setData } = useContext(DataContext);

  const [state, setState] = useState({
    total_nouns: 0,
  });
  const [animation, setAnimation] = useState(null);

  const renderCaption = (index = null, segment = null) => {
    return (
      <span>
        {data.segments.map((s, i) => {
          return (
            <>
              {s.noun === true && s.segment_ids.length > 0 && (
                <strong
                  onClick={() => handleClick(i)}
                  style={{
                    color:
                      (index === null && segment == null) ||
                      index === i ||
                      s.segment_ids.includes(segment)
                        ? data.colors[Math.floor(i / 2)]
                        : "black",
                  }}
                >
                  {i === 0 || s.utterance[0] === "." || s.utterance[0] === ","
                    ? s.utterance
                    : " ".concat("", s.utterance)}
                </strong>
              )}

              {(!s.noun || s.segment_ids.length === 0) && (
                <span>
                  {i === 0 || s.utterance[0] === "." || s.utterance[0] === ","
                    ? s.utterance
                    : " ".concat("", s.utterance)}
                </span>
              )}
            </>
          );
        })}
      </span>
    );
  };

  useEffect(() => {
    var j = 0;
    for (let i = 0; i < data.segments.length; i++) {
      if (data.segments[i].noun === true) {
        j += 1;
      }
      setState({ ...state, total_nouns: j });
    }
  }, []);

  const handleClick = (i) => {
    if (data.playing) {
      handleStop();
    }
    setData((prevData) => ({
      ...prevData,
      index: i,
      segment: null,
    }));
  };

  const handleReset = () => {
    if (data.playing) {
      handleStop();
    }
    setData((prevData) => ({
      ...prevData,
      index: null,
      segment: null,
    }));
  };

  const handlePlay = () => {
    setData({
      ...data,
      segment: 0,
      playing: true,
    });
    let i = -1;
    let interval = setInterval(() => {
      i += 1;
      while (
        i < data.segments.length &&
        data.segments[i].segment_ids.length === 0
      ) {
        i += 1;
      }

      if (i < data.segments.length) {
        setData((prevData) => ({
          ...prevData,
          index: i,
          segment: null,
        }));
      }

      if (i >= data.num_nouns * 2 - 1) {
        clearInterval(interval);
        setTimeout(function () {
          setData((prevData) => ({
            ...prevData,
            index: null,
            segment: null,
            playing: false,
          }));
        }, 1000);
      }
    }, 1000);

    setAnimation(interval);
  };

  const handleStop = () => {
    clearInterval(animation);
    setData((prevData) => ({
      ...prevData,
      playing: false,
    }));
  };

  const handleNext = () => {
    props.fetchData();
  };

  return (
    <Grid id="caption" stackable>
      <Grid.Row columns={3}>
        <Grid.Column textAlign="left">
          <Button circular secondary icon="redo" onClick={handleReset} />
          {!data.playing && (
            <Button circular secondary icon="play" onClick={handlePlay} />
          )}
          {data.playing && (
            <Button secondary circular icon="stop" onClick={handleStop} />
          )}
        </Grid.Column>
        <Grid.Column></Grid.Column>
        <Grid.Column textAlign="right">
          <Button icon labelPosition="right" secondary onClick={handleNext}>
            Next
            <Icon name="right arrow" />
          </Button>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row style={{ textAlign: "justify", padding: "10px" }}>
        <p>{renderCaption(data.index, data.segment)}</p>
      </Grid.Row>
    </Grid>
  );
};
